module.exports = __webpack_public_path__ + "img/微信图片_20251001142706_1974_207.5ed22a8f.jpg";